import { render, staticRenderFns } from "./EscolhaInstrumentoMusicalSelect.vue?vue&type=template&id=f782855e&"
import script from "./EscolhaInstrumentoMusicalSelect.vue?vue&type=script&lang=js&"
export * from "./EscolhaInstrumentoMusicalSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChipGroup,VSelect,VSheet,VTextField})
